var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4544 0.03125L0 22.7364H26.9088L13.4544 0.03125ZM12.3332 8.28768H14.5756V15.5121H12.3332V8.28768ZM13.4544 19.8983C12.6808 19.8983 12.0529 19.3203 12.0529 18.6082C12.0529 17.8961 12.6808 17.3182 13.4544 17.3182C14.228 17.3182 14.8559 17.8961 14.8559 18.6082C14.8559 19.3203 14.228 19.8983 13.4544 19.8983Z",
    fill: "#FF8C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.fef4383b32c4b29118d0d0276e0bdf9d.svg";
export { ForwardRef as ReactComponent };